import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'

interface Props {
  metrics?: ReactNode
  personalisation?: ReactNode
  recentSearches?: ReactNode
  luxPlusTopOffers?: ReactNode
  browseByCategory?: ReactNode
  browseByTrend?: ReactNode
  exploreByIntent?: ReactNode
  campaignBanner?: ReactNode
  topPicks?: ReactNode
  discoverNear?: ReactNode
  lowerContent?: ReactNode
}

const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(36)};

  ${mediaQueryUp.tablet} {
    gap: ${rem(24)};
  }
`

function ExperiencesHomepageUpliftLayout({
  metrics,
  personalisation,
  recentSearches,
  luxPlusTopOffers,
  browseByCategory,
  browseByTrend,
  exploreByIntent,
  campaignBanner,
  topPicks,
  discoverNear,
  lowerContent,
}: Props) {
  return (
    <Sections>
      {metrics}
      {personalisation}
      {recentSearches}
      {browseByCategory}
      {browseByTrend}
      {campaignBanner}
      {luxPlusTopOffers}
      {exploreByIntent}
      {topPicks}
      {discoverNear}
      {lowerContent}
    </Sections>
  )
}

export default ExperiencesHomepageUpliftLayout
